/**
 * Collection View that outputs our repeater field collection to the screen.
 */
define( 'views/fields/preview/repeaterElementCollection',[ 'views/fields/preview/repeaterElementEmpty' ], function( emptyView ) {
	var view = Marionette.CollectionView.extend( {
		tagName: 'div',
		emptyView: emptyView,

		getChildView: function() {
			let view = nfRadio.channel( 'views' ).request( 'get:fieldItem' );
			return view;
		},

		initialize: function( data ) {
			this.emptyViewOptions = {
				repeaterFieldModel: data.repeaterFieldModel,
			};
			this.repeaterFieldModel = data.repeaterFieldModel;

			nfRadio.channel( 'fields-repeater' ).reply( 'init:sortable', this.initSortable, this );
			nfRadio.channel( 'fields-repeater' ).reply( 'get:sortableEl', this.getSortableEl, this );
			nfRadio.channel( 'fields-repeater' ).reply( 'get:repeaterFieldsCollection', this.getRepeaterFieldsCollection, this );
		},

		onRender: function() {
			if ( this.collection.models.length > 0 ) {
				jQuery( this.el ).addClass( 'nf-field-type-droppable' );
				var that = this;
				this.initSortable();
			}
		},

		/**
		 * This sortable is a copy with modifications of the main field list sortable.
		 * 
		 * @since  version
		 * @return {[type]} [description]
		 */
		initSortable: function() {
			// If the sortable has already been instantiated, return early.
			if ( 'undefined' != typeof jQuery( this.el ).sortable( 'instance' ) ) return false;

			jQuery( this.el ).addClass( 'nf-field-type-droppable' ).addClass( 'nf-fields-sortable' );

			let that = this;
			jQuery( this.el ).sortable( {
				containment: 'parent',
				helper: 'clone',
				cancel: '.nf-item-controls',
				placeholder: 'nf-fields-sortable-placeholder',
				opacity: 0.95,
				grid: [ 5, 5 ],
				appendTo: '#nf-main',
				scrollSensitivity: 10,
				//connectWith would allow drag and drop between fields already in the builder and the repeatable fieldset ( this is currently an issue until we deal with existing data stored)
				//connectWith: '.nf-fields-sortable', 

				receive: function( e, ui ) {
					nfRadio.channel( 'fields-repeater' ).request( 'receive:fields', ui, that, e );
				},

				over: function( e, ui ) {
					jQuery(ui.item).addClass("nf-over-repeater");
					if ( ui.item.dropping ) return;
					nfRadio.channel( 'fields-repeater' ).request( 'over:repeaterField', ui, that, e );
				},

				out: function( e, ui ) {
					jQuery(ui.item).removeClass("nf-over-repeater");
					if ( ui.item.dropping ) return;
					nfRadio.channel( 'fields-repeater' ).request( 'out:repeaterField', ui, that, e );
				},

				start: function( e, ui ) {
					if ( ui.item.dropping ) return;
					nfRadio.channel( 'fields-repeater' ).request( 'start:repeaterField', ui, that, e );
				},

				remove: function( e, ui ) {
					// The field is removed from repeater Fields collection and a new one is created for main Fields collection from controllers/fields/sortable/js
					let droppedFieldID = jQuery( ui.item ).data( 'id' );
					let collection = that.repeaterFieldModel.get( 'fields' );
					let droppedFieldModel = collection.get( droppedFieldID );
					
					// Remove the field from the repeater field collection making sure we alert the user the field data is being deleted
					nfRadio.channel( 'app' ).trigger( 'click:delete', e, droppedFieldModel );
				},
				
				// When we update the sort order of our repeater field children, run our sort function.
				update: function( e, ui ) {
					nfRadio.channel( 'fields-repeater' ).request( 'update:repeaterField', ui, that, e );
				},

				stop: function( e, ui ) {
					if ( ui.item.dropping ) return;
					nfRadio.channel( 'fields-repeater' ).request( 'stop:repeaterField', ui, that, e );
				}
			} );
		},

		destroySortable: function() {
			jQuery( this.el ).sortable( 'destroy' );
		},

		/**
		 * When we add our first child, we need to init the sortable.
		 * 
		 * @since  version
		 * @param  {[type]} childView [description]
		 * @return {[type]}           [description]
		 */
		onAddChild: function( childView ) {
			if ( nfRadio.channel( 'fields' ).request( 'get:adding' ) ) {
				childView.$el.hide().show( 'clip' );
				nfRadio.channel( 'fields' ).request( 'set:adding', false);
			}
		},

		/**
		 * Get Element holding child fields
		 */
		getSortableEl: function() {
			return this.el;
		},

		/**
		 * Getter for the repeater Fields collection
		 */
		getRepeaterFieldsCollection: function() {
			return this.repeaterFieldModel.get( 'fields' );
		}
		
	} );

	return view;
} );

